export default __webpack_public_path__ + "static/media/ju_young_an.acdc964f.png";